import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';

/**
 * Konu 4 — Latin ad gösterimi (tek kaynak).
 *
 * Neden gerekli: TMDB, Türkçe çevirisi olmayan kişilerde adı KENDİ yazımıyla
 * döndürüyor (上村侑, Дарья Пиманова). Bu adlar Türk kullanıcı için okunamaz ve
 * klavyeyle yazılamadığı için aranamaz. `people.latin_name` bu kişiler için
 * TMDB en-US'ten gelen gerçek romanizasyonu tutar.
 *
 * Sunucu tarafındaki eşdeğeri: `App\Support\LatinNameLock::displayName()` ve
 * `Person::$display_name`. İKİSİ AYNI KARARI VERMELİ — aksi halde bot'un
 * gördüğü prerender HTML ile hydrate sonrası SPA çıktısı çelişir.
 */

/** Bayrak istek boyunca sabit; hook'a gerek yok, helper'lardan da çağrılabilir. */
function displayEnabled(): boolean {
  return getBootstrapData()?.settings?.latin_names_display_enabled === true;
}

interface HasName {
  name?: string | null;
  latin_name?: string | null;
}

/**
 * Gösterilecek ad: Latin karşılığı varsa o, yoksa orijinal.
 * Bayrak kapalıyken her zaman orijinal → davranış bugünküyle birebir aynı.
 */
export function getPersonDisplayName(person?: HasName | null): string {
  const name = person?.name?.trim() ?? '';
  if (!displayEnabled()) return name;
  return person?.latin_name?.trim() || name;
}

/**
 * İkincil (orijinal) yazım — kişi detayında Latin adın altında gösterilir.
 * Yalnız gerçekten farklı bir Latin ad gösteriliyorsa döner, aksi halde null
 * (aynı ad iki kez yazılmasın).
 */
export function getPersonSecondaryName(person?: HasName | null): string | null {
  const name = person?.name?.trim() ?? '';
  const display = getPersonDisplayName(person);
  return name && display && display !== name ? name : null;
}
